@if (giftcard) {
<div class="m-t-2 m-b-2">
    <div class="flex flex-justify-between col-12">
        <p class="m-b-2">
            <span>{{'Gift card amount applied' | translate}}</span><span *ifSize="'!S'">&nbsp;({{lastFour}})</span>
        </p>
        <price [value]="value"
               [precision]="2"></price>
    </div>
    <!-- remove coupon -->
    <action class="button-inline m-t-2"
            [attr.aria-label]="'Remove' | translate"
            [status]="status"
            (click)="remove()">
        <span class="c1">{{'Remove' | translate}}</span>
    </action>
    <result class="block col-2 fs-3 m-t-1"
            [status]="status"></result>
</div>
}
